import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CircleEventNode } from "./CircleEventNode";
function ProcessFlowEventNode({ data }) {
    if (!data) return null;
    return /*#__PURE__*/ _jsx(CircleEventNode, {
        data: data
    });
}
export default /*#__PURE__*/ memo(ProcessFlowEventNode);

//# sourceMappingURL=EventNode.js.map